module.exports = __webpack_public_path__ + "img/Compact-Assembly.fd7126dd.jpg";